import { validators } from './validators';

// Validate product form
export const validateProductForm = (formData) => {
  const errors = {};

  // Required fields
  if (!formData.name || !formData.name.trim()) {
    errors.name = 'Product name is required';
  } else if (formData.name.length < 3) {
    errors.name = 'Product name must be at least 3 characters';
  } else if (formData.name.length > 200) {
    errors.name = 'Product name must not exceed 200 characters';
  }

  if (!formData.category_id) {
    errors.category_id = 'Category is required';
  }

  // Price validation
  if (!formData.price || formData.price === '') {
    errors.price = 'Price is required';
  } else {
    const price = parseFloat(formData.price);
    if (isNaN(price) || price < 0) {
      errors.price = 'Price must be a positive number';
    }
  }

  // Compare price validation
  if (formData.compare_price) {
    const price = parseFloat(formData.price);
    const comparePrice = parseFloat(formData.compare_price);
    
    if (isNaN(comparePrice) || comparePrice < 0) {
      errors.compare_price = 'Compare price must be a positive number';
    } else if (comparePrice <= price) {
      errors.compare_price = 'Compare price must be greater than selling price';
    }
  }

  // Cost validation
  if (formData.cost_per_item) {
    const cost = parseFloat(formData.cost_per_item);
    if (isNaN(cost) || cost < 0) {
      errors.cost_per_item = 'Cost must be a positive number';
    }
  }

  // Quantity validation
  if (formData.track_inventory) {
    const quantity = parseInt(formData.quantity);
    if (isNaN(quantity) || quantity < 0) {
      errors.quantity = 'Quantity must be a non-negative number';
    }
  }

  // Number of pieces validation
  if (formData.number_of_pieces !== undefined && formData.number_of_pieces !== '') {
    const pieces = parseInt(formData.number_of_pieces);
    if (isNaN(pieces) || pieces < 1) {
      errors.number_of_pieces = 'Number of pieces must be at least 1';
    }
  }

  // Weight validation
  if (formData.weight) {
    const weight = parseFloat(formData.weight);
    if (isNaN(weight) || weight <= 0) {
      errors.weight = 'Weight must be a positive number';
    }
  }

  // SKU validation
  if (formData.sku && formData.sku.length > 100) {
    errors.sku = 'SKU must not exceed 100 characters';
  }

  // Barcode validation
  if (formData.barcode && formData.barcode.length > 100) {
    errors.barcode = 'Barcode must not exceed 100 characters';
  }

  // Description validation
  if (formData.description && formData.description.length > 5000) {
    errors.description = 'Description must not exceed 5000 characters';
  }

  // Meta title validation
  if (formData.meta_title && formData.meta_title.length > 200) {
    errors.meta_title = 'Meta title must not exceed 200 characters';
  }

  // Meta description validation
  if (formData.meta_description && formData.meta_description.length > 500) {
    errors.meta_description = 'Meta description must not exceed 500 characters';
  }

  // Slug validation
  if (formData.slug) {
    const slugRegex = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
    if (!slugRegex.test(formData.slug)) {
      errors.slug = 'Slug must be lowercase letters, numbers, and hyphens only';
    }
  }

  // Rental validation
  if (formData.is_rental) {
    // WhatsApp number validation
    if (!formData.whatsapp_number || !formData.whatsapp_number.trim()) {
      errors.whatsapp_number = 'WhatsApp number is required for rental items';
    } else {
      const whatsappRegex = /^[0-9]{10,15}$/;
      if (!whatsappRegex.test(formData.whatsapp_number)) {
        errors.whatsapp_number = 'WhatsApp number must be 10-15 digits';
      }
    }

    // Rent per month validation
    if (!formData.rent_per_month || formData.rent_per_month === '') {
      errors.rent_per_month = 'Rent per month is required for rental items';
    } else {
      const rent = parseFloat(formData.rent_per_month);
      if (isNaN(rent) || rent < 0) {
        errors.rent_per_month = 'Rent per month must be a non-negative number';
      }
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

// Validate inventory update
export const validateInventoryUpdate = (quantity) => {
  const qty = parseInt(quantity);
  
  if (isNaN(qty) || qty < 0) {
    return 'Quantity must be a non-negative number';
  }
  
  return null;
};

// Validate price update
export const validatePriceUpdate = (price) => {
  const priceNum = parseFloat(price);
  
  if (isNaN(priceNum) || priceNum < 0) {
    return 'Price must be a positive number';
  }
  
  return null;
};

// Validate bulk actions
export const validateBulkAction = (selectedIds, action) => {
  if (!selectedIds || selectedIds.length === 0) {
    return 'Please select at least one product';
  }
  
  if (!action) {
    return 'Please select an action';
  }
  
  return null;
};

export default {
  validateProductForm,
  validateInventoryUpdate,
  validatePriceUpdate,
  validateBulkAction,
};